const getDocMsg = ($t, res) => {
  let s = '<b><ul>'
  if (res && Array.isArray(res.data)) {
    for (let i = 0; i < res.data.length; ++i) {
      let r = res.data[i]
      if (r.statement_id) {
        s += `<li>${$t('api.actions.voidDocument.voidStmtID')}: ${r.statement_id}</li>`
      } else if (r.document_id) {
        s += `<li>${$t('api.actions.voidDocument.voidDocNum')}: ${r.document_number}</li>`
      }
    }
  }
  return s + '</ul></b>'
}

export function confirmVoidRes (res, id) {
  if (res.code === 4704 || res.code === 4707) {
    let title = this.$t('api.actions.voidDocument.voidFirstTitle')
    let msg = this.$t('api.actions.voidDocument.voidFirstMsg') +
      getDocMsg(this.$t, res)

    if (res.code === 4707) {
      title = this.$t('api.actions.voidDocument.voidNoTitle')
      msg = this.$t('api.actions.voidDocument.voidByEditingBookings', {
        id: id || this.row.doc_id
      }) +
        getDocMsg(this.$t, res)
    }

    this.$confirm(msg, title,
      {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonLoading: false,
        showConfirmButton: false,
        showCancelButton: true
      }
    ).catch(() => {
      // do nothing
    })
    return true
  }
}
